import './NavbarRefreshButton.css';
import React from 'react';
import { showConfirmCancelModal } from '@vse-legacy/widgets';
import { remoteSupportServices } from '@src/RemoteSupportServices';

/**
 * Creates a button that refreshes the page.
 * @returns {JSX.Element} The NavbarRefreshButtonButton React component.
 */
export function NavbarRefreshButton (): JSX.Element {
  const handleRefresh = (): void => {
    const lIsInSupportCall = remoteSupportServices.isActive();

    if (lIsInSupportCall) {
      showConfirmCancelModal(
        { text: 'Are you sure?' },
        { text: 'Please note your remote support call will disconnect if you continue with refresh' },
        { text: 'Continue with refresh', style: { height: '41px', width: '191px' }, onClick: () => { window.location.reload(); } },
        { text: 'Cancel', style: { height: '41px', width: '191px' } },
      );
      return;
    }
    window.location.reload();
  };

  return (
    <div className="navbar-refresh-button" onClick={handleRefresh}>
      <i className="navbar-icon icon-redo"></i>
      <span>Refresh</span>
    </div>
  );
}
